<div *ngIf="!props.hidden">
    <ng-template #fieldComponent></ng-template>
</div>